import React, {useEffect, useState} from 'react';
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import EmptyBox from "components/emptyBox/EmptyBox";
import Space from "components/space/Space";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";
import queryString from "query-string";
import TitleAddHeader from "../address/TitleAddHeader";
import Pagination from "components/list/Pagination";
import {useHistory} from "react-router-dom";
import IconTitleValue from "components/textValue/IconTitleValue";
import moment from "jalali-moment";
import RechargeWalletBox from "../wallet/RechargeWalletBox";
import Dialog from '@material-ui/core/Dialog';
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";

import ICAddIcon from '@mui/icons-material/Add';
import ICSuccess from "res/images/success.png";
import ICError from "res/images/error.png";
import ICReward from "res/images/wallet.png";
import {Helmet} from "react-helmet";

export default function Wallet(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const limit = 15

    const [pages, setPages] = useState([])
    const [transactions, setTransactions] = useState([])
    const [wallet, setWallet] = useState(0)
    const [open, setOpen] = useState(false)
    const [dialogMessageShowStatus, setDialogMessageShowStatus] = useState(false)
    const [dialogMessageShowText, setDialogMessageShowText] = useState(false)

    function requestGetWallet() {
        callEmptyParamsApi(Urls.getCustomerWallet, (data) => {
                if (data && data.wallet && data.wallet.current_value) {
                    setWallet(data.wallet.current_value)
                } else {
                    setWallet(0)
                }
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    function requestGetWalletTransactions() {
        let params = new FormData();
        params.append("limit", limit);
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        callApi(Urls.getWalletTransactions, params, (data) => {

            if (data && data.list && data.list.length > 0) {
                setTransactions(data.list);
                requestWalletTransactionsCount()
            } else {
                setTransactions([])
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestWalletTransactionsCount() {
        callEmptyParamsApi(Urls.getWalletTransactionsCount, (data) => {
            let number = data.count / limit;

            if (data.count % limit > 0) {
                number++
            }

            let tempPages = []
            for (let i = 1; i <= number; i++) {
                tempPages.push({
                    number: i,
                    selected: i === parseInt(urlParams.p)
                })
            }

            setPages(tempPages)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestChargeWallet(amount) {
        let params = new FormData()
        params.append("price", amount)
        callApi(Urls.chargeWallet, params, (data) => {
            if (data.description === 200) {
                props.onNavigate(history, "/beforeWalletPayment?token=" + data.request_id)
            } else {
                props.onAlert(data.message)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function manageShowDescription(text, status) {
        if (text != null && text !== '' && text !== ' ') {
            setDialogMessageShowText(text)
            setDialogMessageShowStatus(status)
        } else {
            setDialogMessageShowText(null)
            setDialogMessageShowStatus(false)
        }
    }

    function pushToHistory(p) {
        props.onNavigate(history, '/wallet?p=' + p)
    }

    function onNumberClick(number) {
        pushToHistory(number)
    }

    function onNextClick() {
        pushToHistory((parseInt(urlParams.p) + 1))
    }

    function onBackClick() {
        pushToHistory((parseInt(urlParams.p) - 1))
    }

    useEffect(() => {
        requestGetWallet()
        requestGetWalletTransactions()
        requestWalletTransactionsCount()
    }, [])

    return (
        <>
            <Helmet>
                <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - Ú©ÛÙ Ù¾ÙÙ</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                <meta property="og:url" content="https://sarfemarket.ir/" />
            </Helmet>
            <div className="hInLPT_vInFMS wInLPT100_wInFMS95 paddingTopInTPMS">
                <div className="marginLeftRightSmall wInLP60_wInT50_wInFMS100">
                    <div className="marginTopBottomSmall">
                        <TitleAddHeader
                            hideicon={"true"}
                            title={messages.wallet}/>
                    </div>
                    <div>
                        <div className="walletBox">
                            <div className="walletBoxInto">
                                <div style={{margin: '1rem 2rem'}}>
                                    Ú©ÛÙ Ù¾ÙÙ ÙÙ
                                </div>
                                <div style={{textAlign: 'center'}}>
                                    {parseInt(wallet).toLocaleString()} ØªÙÙØ§Ù
                                </div>
                                <div
                                    style={{textAlign: 'center'}} className="rechargeWallet"
                                    onClick={() => {
                                        setOpen(true)
                                    }}>
                                    <ICAddIcon/>
                                    Ø§ÙØ²Ø§ÛØ´ ÙÙØ¬ÙØ¯Û
                                </div>
                            </div>

                        </div>
                        <Space height={"1em"}/>
                        <Divider/>
                        <Space/>
                        {transactions.length > 0 ?
                            <div className="wInP50_wInTFM100 transactionListCard">
                                <Dialog open={dialogMessageShowStatus} onClose={dialogMessageShowStatus}
                                        style={{height: 'auto'}} classes={'DialogStyle'}>
                                    <div>
                                        <p className="marginTopBottomSmall titleBoxAmountRecharge" style={{minWidth: '15rem'}}>
                                            ØªÙØ¶ÛØ­Ø§Øª ØªØ±Ø§Ú©ÙØ´
                                        </p>
                                        <div>
                                            <div className="selectAmountBox">
                                                {dialogMessageShowText}
                                            </div>
                                        </div>

                                        <div style={{display: 'flex'}} className="submitRechargeButton">
                                            <div className="marginTopBottomSmall" style={{width: '88%'}}>
                                                <IconTitleButtonRound
                                                    borderradius={"0.5rem"}
                                                    backgroundcolor={"var(--blue_3)"}
                                                    height={"3em"}
                                                    width={"100%"}
                                                    direction="ltr"
                                                    fontSize="mediumTextBold"
                                                    lineHeight="1rem"
                                                    title="ØªØ§ÛÛØ¯"
                                                    onClick={() => {
                                                        manageShowDescription('', false)
                                                    }}/>
                                            </div>

                                        </div>

                                    </div>

                                </Dialog>
                                {transactions.map((transaction, index) => {
                                    if (transaction) {
                                        let transactionName = transaction.wallet_transaction_type_description;
                                        let requestId = transaction.request_id > 0 ? transaction.request_id : transaction.organization_id > 0 ? transaction.org_name : '';
                                        let transactionTime = transaction.date_added.split(" ");

                                        return (<div key={index} className="transactionListCardItem"
                                                     onClick={() => {
                                                         manageShowDescription(transaction.description, true)
                                                     }}>
                                            <div className="horizontalFullScreen">
                                                <div className="fullWidth">
                                                    <IconTitleValue
                                                        title={transaction.transaction_type_description + ' - ' + transactionName}
                                                        titleClassName={transaction.transaction_type && parseInt(transaction.transaction_type) === 1 ? "greenColor mediumTextBold" : "redColor mediumTextBold"}
                                                        icon={<img
                                                            src={transaction.transaction_type && parseInt(transaction.transaction_type) === 1 ? ICSuccess : ICError}
                                                            alt="" className="smallIcon marginTopXSmall"/>}/>
                                                </div>
                                                <div className="marginLeftSmall">
                                                    <IconTitleValue
                                                        title={transactionTime[1].split(":")[0] + ':' + transactionTime[1].split(":")[1]}
                                                        titleClassName={"mediumTextBold marginTopBottomMedium"}
                                                        value={moment(transaction.date_added, 'YYYY/MM/DD')
                                                            .locale('fa')
                                                            .format('YYYY/MM/DD')}
                                                        valueClassName={"mediumTextBold marginTopBottomMedium"}/>
                                                </div>
                                            </div>
                                            <div className="horizontalFullScreen"
                                                 style={{display: 'flex', justifyContent: 'space-between'}}>
                                                <div className="fullWidth marginRightMedium responseStylCurrent_value">
                                                    <IconTitleValue
                                                        valueClassName={"mediumTextBold"}
                                                        title={messages.fee}
                                                        value={parseInt(transaction.current_value).toLocaleString('fa-IR') + ' ØªÙÙØ§Ù'}/>
                                                </div>
                                                {requestId !== '' &&
                                                    <div className="marginLeftSmall wallet_transaction_type">
                                                        <IconTitleValue
                                                            title={messages.paymentCode}
                                                            valueClassName={"mediumTextBold"}
                                                            value={requestId}/>
                                                    </div>
                                                }
                                            </div>
                                            <Space height={"0.5em"}/>
                                        </div>)
                                    }
                                })}
                            </div> :
                            <div>
                                <Space/>
                                <EmptyBox message={messages.list + '' + messages.isEmpty}/>
                            </div>
                        }
                        {(transactions.length > 0 && pages.length > 1) &&
                            <div style={{float: "left"}}>
                                <br/>
                                <Pagination
                                    pages={pages}
                                    onNumberClick={() => {
                                        onNumberClick()
                                    }}
                                    onNextClick={() => {
                                        onNextClick()
                                    }}
                                    onBackClick={() => {
                                        onBackClick()
                                    }}/>
                            </div>
                        }
                    </div>
                    <RechargeWalletBox
                        {...props}
                        open={open}
                        onSubmit={(amount) => {
                            setOpen(false)
                            requestChargeWallet(amount)
                        }}
                        close={() => {
                            setOpen(false)
                        }}/>
                </div>
                <div className="marginTopBottomMedium showInLPT_hideInFMS wInLP40_wInT50_wInFMS100">
                    <img className="fullWidth" src={ICReward} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                </div>
            </div>
        </>
       )

}